import * as MaRequests from '@/base/ma-requests/index.js'

let _Vue = null

export default {
  install(app, options = { isDebug: false }) {
    if (this.installed && _Vue === app) {
      return
    }
    this.installed = true
    _Vue = app

    /**
     * Convenience method for accessing products;
     * @type Object
     */
    app.$maRequests = MaRequests
    app.config.globalProperties.$maRequests = MaRequests
    if (options.isDebug && window) {
      window.MaRequests = MaRequests
    }
  },
}
